export default __webpack_public_path__ + "static/media/Chevron up.d30eba7d.svg";